<template>
<div class="chapter">
<div class="inner_page">
<p class="map"><span href="#/OEBPS/toc#maps" id="maps1" title="Link target outside of Sample"><strong>Maps</strong></span></p>
<p class="dispimg" id="map1"><img alt="" src="OEBPS/images/map-viii.jpg"/></p>
<p class="map1">Central Europe, September 1940</p>
<p class="dispimg" id="map2"><img alt="" src="OEBPS/images/map-x.jpg"/></p>
<p class="map1">The Limit of German Occupation of Europe, December 1941</p>
<p class="dispimg" id="map3"><img alt="" src="OEBPS/images/map-xii.jpg"/></p>
<p class="map1">The Eastern Mediterranean in the Second World War</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?38436005